<template>
  <div>
    <!-- <div style="overflow: hidden">
      <el-row style="float: right; margin-right: 20px; margin-top: 20px">
        <el-button
          style="background-color: #b5ac8b; color: white"
          @click="$router.push('/index/apartment/customerInformation')"
          >列表模式</el-button
        >
      
      </el-row>
    </div> -->
    <!-- 房态图 -->
    <div class="partOne">
      <div
        class="roomNumCard"
        style="background-image: linear-gradient(to top right, #59d3ff, #f36f85)"
      >
        <p>客房总数</p>
        <p>
          <span>{{ sum }}</span> <span>间</span>
        </p>
      </div>
      <div
        class="roomNumCard"
        style="background-image: linear-gradient(to top right, #ec9566, #f9b16a)"
      >
        <p>待入住</p>
        <p>
          <span>{{ toBeCheckIn }}</span> <span>间</span>
        </p>
      </div>
      <div
        class="roomNumCard"
        style="background-image: linear-gradient(to top right, #02aab0, #00cdac)"
      >
        <p>空闲中</p>
        <p>
          <span>{{ free }}</span> <span>间</span>
        </p>
      </div>

      <div
        class="roomNumCard"
        style="background-image: linear-gradient(to top right, #2f80ed, #56ccf2)"
      >
        <p>已入住</p>
        <p>
          <span>{{ checkedIn }}</span
          ><span>间</span>
        </p>
      </div>
      <div
        class="roomNumCard"
        style="background-image: linear-gradient(to top right, #ed5564, #f36f85)"
      >
        <p>待退房</p>
        <p>
          <span>{{ checkOut }}</span> <span>间</span>
        </p>
      </div>
      <div
        class="roomNumCard"
        style="background-image: linear-gradient(to top right, #536170, #6f7b89)"
      >
        <p>维护中</p>
        <p>
          <span>{{ maintain }}</span> <span>间</span>
        </p>
      </div>
    </div>

    <div style="width: 100%; margin: 40px 0 20px 20px">
      <el-form :model="queryRoomPicture" :inline="true" label-width="100px">
        <el-form-item label="房间号">
          <el-input
            placeholder="请输入房间号"
            v-model="queryRoomPicture.roomNumber"
            clearable
          >
          </el-input>
        </el-form-item>
        <el-form-item label="单位名称">
          <el-autocomplete
            v-model="queryRoomPicture.company"
            :fetch-suggestions="querySearchAsync2"
            placeholder="请输入单位名称"
            value-key="unitName"
            clearable
            @clear="clearSearch"
            ref="myAutocomplete"
          >
          </el-autocomplete>
        </el-form-item>
        <el-form-item label="入住时间">
          <el-date-picker
            v-model="closeDate"
            type="daterange"
            range-separator="至"
            start-placeholder="开始日期"
            end-placeholder="结束日期"
            placeholder="选择日期"
            style="width: 100%"
            value-format="yyyy-MM-dd hh:mm:ss"
          />
        </el-form-item>
        <el-form-item>
          <el-button @click="roomNumberQuery" type="primary">搜索</el-button>
        </el-form-item>
        <el-form-item>
          <el-button
          style="background-color: #b5ac8b; color: white"
          @click="isShow = !isShow"
          >{{ isShow ? "列表模式" : "房图模式" }}</el-button
        >
        </el-form-item>
        <div>{{ sums }}</div>
      </el-form>
    </div>

    <section class="background">
      <div class="partTwo">
        <div class="queryCondition">
          <p>
            状态：
            <span
              v-for="(item, index) in stateArr"
              :class="{ isSelected: statusHigh.includes(index) }"
              @click="stateClick(item, index)"
              >{{ item }}</span
            >
          </p>
          <p v-show="buildingShow">
            楼栋：<span
              v-for="(item, index) in buildingList"
              @click="buildingClick(item, index)"
              :class="{ isSelected: buildingsHigh.includes(index) }"
              >{{ item.building }}</span
            >
          </p>
          <p v-show="buildingShow">
            楼层：<span
              v-for="(item, index) in storeyList"
              :class="{ isSelected: storeysHigh.includes(index) }"
              @click="storeyClick(item, index)"
              >{{ item }}</span
            >
          </p>
        </div>
        <template v-if="tableData.length > 0">
          <!-- <p
            style="
              width: 100%;
              background-color: #e7e9ef;
              height: 1px;
              margin: 0px 30px 20px;
            "
          ></p> -->
          <div class="allRooms">
            <div
              v-show="isShow"
              class="roomCard"
              v-for="(item, index) in tableData"
              @click="roomDetailClick(item)"
            >
              <div style="display: flex; justify-content: space-between">
                <div>
                  <div style="display: flex">
                    <div>
                      <div
                        v-if="item.status == '空闲中'"
                        style="
                          background-color: #48cfae;
                          width: 40px;
                          height: 40px;
                          text-align: center;
                          line-height: 40px;
                        "
                      >
                        闲
                      </div>
                      <div
                        v-if="item.status == '已入住'"
                        style="
                          background-color: #51c1e9;
                          width: 40px;
                          height: 40px;
                          text-align: center;
                          line-height: 40px;
                        "
                      >
                        住
                      </div>
                      <div
                        v-if="item.status == '维护中'"
                        style="
                          background-color: #536170;
                          width: 40px;
                          height: 40px;
                          text-align: center;
                          line-height: 40px;
                        "
                      >
                        维
                      </div>
                      <div
                        v-if="item.status == '待入住'"
                        style="
                          background-color: #f2a268;
                          width: 40px;
                          height: 40px;
                          text-align: center;
                          line-height: 40px;
                        "
                      >
                        待
                      </div>
                    </div>
                    <div
                      style="
                        line-height: 40px;
                        margin-left: 20px;
                        font-weight: 600;
                        font-size: 21px;
                      "
                    >
                      {{ item.roomNumber }}
                    </div>
                  </div>
                  <div>所属：{{ item.abbreviation }}</div>
                  <div style="margin: 3px 0">
                    人才：{{ item.name == null ? "暂无" : item.name }}
                  </div>
                  <div>手机：{{ item.phone == null ? "暂无" : item.phone }}</div>
                </div>
                <div>
                  <div
                    @click.stop="isZt(item)"
                    style="
                      border: 1px solid #999;
                      padding: 3px 20px;
                      border-radius: 15px;
                      cursor: pointer;
                    "
                  >
                    入住
                  </div>
                  <div
                    @click.stop="isTf(item)"
                    style="
                      border: 1px solid #999;
                      padding: 3px 20px;
                      border-radius: 15px;
                      margin-top: 10px;
                      cursor: pointer;
                    "
                  >
                    退房
                  </div>
                </div>

                <!-- <p>{{item.roomNumber?item.roomNumber:0}}</p>
							<p>{{item.abbreviation}}</p> -->
              </div>
            </div>

            <div v-show="!isShow" class="list">
              <CustomerInformation :tableData="tableData" @getList="getAll" />
            </div>
          </div>
          <el-pagination
            background
            :page-size="pageSize"
            layout="total, prev, pager, next,sizes"
            @current-change="handleCurrentChange"
            :total="totalNum"
            @size-change="handleSizeChange"
          />
        </template>

        <template v-if="adjustRoomData.length > 0">
          <div
            style="
              display: flex;
              width: 100%;
              justify-content: space-between;
              margin: 20px 30px 20px;
            "
          >
            <p style="color: #333333; font-weight: bolder">调剂房</p>
            <p
              style="width: 95%; background-color: #e7e9ef; height: 1px; margin-top: 10px"
            ></p>
          </div>
          <div class="allRooms">
            <div
              class="roomCard"
              v-for="(item, index) in adjustRoomData"
              @click="roomDetailClick(item)"
            >
              <span style="background-color: #f2a268">入、出</span>
              <p>{{ item.roomNumber ? item.roomNumber : 0 }}</p>
              <p>{{ item.company }}</p>
            </div>
          </div>
        </template>
      </div>
      <div
        v-show="img"
        style="font-size: 50px; text-align: center; margin-left: -200px; color: #b0b0b0"
      >
        暂无数据
      </div>
    </section>
  </div>
</template>

<script>
import CustomerInformation from "./customerInformation";
export default {
  components: { CustomerInformation },
  data() {
    return {
      img: false,
      checkList: [],
      input3: null,
      ceshi: null,
      roomList: [1, 2, 3, 4, 5, 7, 7],
      tableData: [],
      pageSize: 10, //
      currentPage: 1, //当前页号
      totalNum: 0, //总页数，
      isShow: true,
      sum: 0, //所有客房数量
      free: 0, //空闲中数量
      checkedIn: 0, //已入住数量
      toBeCheckIn: 0, //待入住数量
      maintain: 0, //维护中数量
      checkOut: 0, //退房中数量

      stateArr: ["全部", "空闲中", "已入住", "维护中", "待入住", "待退房"],
      buildingList: [], //楼栋
      storeyList: [], //楼层
      stateIndex: 0,
      buildingIndex: 0,
      storeyIndex: 0,
      closeDate: [],
      queryRoomPicture: {
        building: null, //楼栋
        company: "",
        roomNumber: null, //房间号
        status: null, //状态
        storey: null, //楼层,
        // company: null,
        buildings: [],
        storeys: [],
        statusList: ["全部"],
      },
      buildingShow: false,
      adjustRoomData: [],
      buildingsHigh: [],
      statusHigh: [0],
      storeysHigh: [],
      sums: "",
    };
  },
  mounted() {
    let a = this.$route.params;
    this.ceshi = this.$route.params.ceshi;
    console.log(a);
    this.getBuildingAndStorey();
    this.getCountRoom();
    this.getAdjustRoom();
  },
  methods: {
    isZt(val) {
      console.log(JSON.stringify(val));
      if (val.status == "已入住") {
        let msg = val.roomNumber + "已经有人才" + val.name + "入住，需先办理退房业务";
        this.$alert(msg, "通知", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return;
      }
      if (val.status == "维护中") {
        let msg = val.roomNumber + "正在维护中，" + "还请另选房屋";
        this.$alert(msg, "通知", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return;
      }
      if (val.status == "空闲中") {
        this.$alert("该房间暂无人才入住,为您跳转人才入住申请", "通知", {
          confirmButtonText: "确定",
          callback: (action) => {
            this.$router.push({
              name: "入住",
              query: {
                name: val.company,
              },
            });
          },
        });
        return;
      }
      if (val.status == "待入住") {
        this.$router.push("/index/apartment/checkIn");
        return;
      }
    },
    isTf(val) {
      if (val.status == "维护中") {
        let msg = val.roomNumber + "正在维护中，" + "还请另选房屋";
        this.$alert(msg, "通知", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return;
      }
      if (val.status == "空闲中") {
        let msg = val.roomNumber + "无人才入住，" + "无法办理退房手续";
        this.$alert(msg, "通知", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return;
      }
      if (val.status == "已入住") {
        this.$router.push("/index/apartment/exitIn");
        return;
      }
      if (val.status == "待入住") {
        let msg = val.roomNumber + "已有人才待入住，" + "尚未办理入住手续";
        this.$alert(msg, "通知", {
          confirmButtonText: "确定",
          callback: (action) => {},
        });
        return;
      }
    },
    // 条件查询房态图
    getAll() {
      if (this.queryRoomPicture.buildings.includes("全部")) {
        this.queryRoomPicture.buildings = [];
      }
      if (this.queryRoomPicture.statusList.includes("全部")) {
        this.queryRoomPicture.statusList = [];
      }
      if (this.queryRoomPicture.storeys.includes("全部")) {
        this.queryRoomPicture.storeys = [];
      }
      let checkInTime = null;
      let dueTime = null;
      if (this.closeDate.length > 1) {
        checkInTime = this.closeDate[0];
        dueTime = this.closeDate[1];
      }
      this.$http
        .post("/api/roomManage/queryRoomPicture", {
          // .post("/api/roomManage/queryRoom", {
          ...this.queryRoomPicture,
          checkInTime,
          dueTime,
          pageSize: this.pageSize,
          currentPage: this.currentPage,
        })
        .then((res) => {
          this.tableData = res.data.data.items;
          this.totalNum = res.data.data.totalNum;
          this.sums = res.data.data.sum;
          this.img = false;
          if (this.tableData.length == 0) {
            this.img = true;
          }
        });
    },
    // 查询调剂房态图
    getAdjustRoom() {
      this.$http.post("/api/roomManage/queryRoomAdjustmentPicture").then((res) => {
        console.log(res);

        this.adjustRoomData =
          res.data.data.adjustmentInRoomList == null
            ? []
            : res.data.data.adjustmentInRoomList;
        console.log(this.adjustRoomData);
      });
    },
    // 各个状态统计客房数
    getCountRoom() {
      this.$http.get("/api/roomManage/countRoom").then((res) => {
        console.log("客房统计查询结果：", JSON.stringify(res.data));
        this.sum = res.data.data.sum;
        this.free = res.data.data.free;
        this.maintain = res.data.data.maintain;
        this.toBeCheckIn = res.data.data.toBeCheckIn;
        this.checkedIn = res.data.data.checkedIn;
        this.checkOut = res.data.data.checkOut;
      });
    },
    // 获取楼栋和楼层
    getBuildingAndStorey() {
      this.$http
        .post("/api/roomManage/getBuildingAndStorey", {
          company: this.queryRoomPicture.company,
          pageSize: this.pageSize,
          currentPage: this.currentPage,
          roomNumber: this.queryRoomPicture.roomNumber,
          status: this.queryRoomPicture.status,
        })
        .then((res) => {
          console.log("楼层", res);
          this.buildingList = res.data.data;
          if (this.buildingList.length == 0) {
            this.buildingShow = false;
            this.getAll();
            return;
          }
          this.buildingShow = true;
          let storeyList = JSON.stringify(res.data.data[0].storeyList);
          this.storeyList = JSON.parse(storeyList);
          this.storeyList.unshift("全部");
          this.storeysHigh.unshift(0);
          this.buildingsHigh.unshift(0);
          this.queryRoomPicture.buildings = [res.data.data[0].building];
          this.queryRoomPicture.storeys = [this.storeyList[0]];

          // 等拿到楼栋和楼层在渲染房间
          this.getAll();
        });
    },

    // 点击状态
    stateClick(val, index) {
      // this.stateIndex = index;
      // this.queryRoomPicture.status = this.stateArr[index];
      // console.log('queryRoomPicture:',JSON.stringify(this.queryRoomPicture))
      const isReturn =
        this.queryRoomPicture.statusList.includes(val) &&
        this.queryRoomPicture.statusList === 1;
      if (isReturn) return;
      if (val === "全部") {
        this.statusHigh = [0];
        this.queryRoomPicture.statusList = ["全部"];
        this.getAll();
        return;
      }
      const indexInArr = this.statusHigh.indexOf(index);
      if (indexInArr === -1) {
        this.statusHigh.push(index);
        this.queryRoomPicture.statusList.push(val);
        if (this.statusHigh.includes(0)) {
          this.statusHigh.shift(0);
          // console.log(this.statusHigh, this.queryRoomPicture.statusList, '22');
        }
        if (this.queryRoomPicture.statusList.includes("全部")) {
          this.queryRoomPicture.statusList.shift("全部");
        }
      } else {
        if (this.statusHigh.length === 1) return;
        this.statusHigh.splice(indexInArr, 1);
        this.queryRoomPicture.statusList = this.queryRoomPicture.statusList.filter(
          (str) => str !== val
        );
      }
      this.getAll();
      // this.getBuildingAndStorey();
      // console.log(this.queryRoomPicture.statusList,this.statusHigh, 'this.queryRoomPicture.statusList');
    },
    // 点击楼栋
    buildingClick(val, index) {
      const isReturn =
        this.queryRoomPicture.buildings.includes(val.building) &&
        this.queryRoomPicture.buildings.length === 1;
      if (isReturn) return;
      // console.log(val, 'val');
      if (val.building === "全部") {
        this.buildingsHigh = [index];
        this.queryRoomPicture.buildings = ["全部"];
        this.storeysHigh = [index];
        this.queryRoomPicture.storeys = ["全部"];
        this.storeyList = this.buildingList[0].storeyList;
        this.storeyList.unshift("全部");
        this.getAll();
        return;
      }
      const indexInArr = this.buildingsHigh.indexOf(index);
      if (indexInArr === -1) {
        this.buildingsHigh.push(index);
        this.queryRoomPicture.buildings.push(val.building);
        if (this.buildingsHigh.includes(0)) {
          this.buildingsHigh = this.buildingsHigh.filter((item) => item !== 0);
        }
        if (this.queryRoomPicture.buildings.includes("全部")) {
          this.queryRoomPicture.buildings = this.queryRoomPicture.buildings.filter(
            (item) => item !== "全部"
          );
        }
      } else {
        this.buildingsHigh.splice(indexInArr, 1);
        this.queryRoomPicture.buildings = this.queryRoomPicture.buildings.filter(
          (str) => str !== val.building
        );
        console.log(arr, this.queryRoomPicture.buildings, val.building, "arr");
      }
      let arr = [];
      this.queryRoomPicture.buildings.forEach((i) => {
        this.buildingList.forEach((v) => {
          if (i === v.building) {
            arr.unshift(...v.storeyList);
            //   arr = [...v.storeyList, ...arr]
          }
        });
      });
      arr.unshift("全部");
      const arr2 = this.separateAndSort(arr);
      this.storeyList = arr2;
      this.getAll();
    },
    // 点击楼层
    storeyClick(val, index) {
      const isReturn =
        this.queryRoomPicture.storeys.includes(val) &&
        this.queryRoomPicture.storeys === 1;
      if (isReturn) return;
      // this.storeyIndex = index;
      // this.queryRoomPicture.storey = this.storeyList[index];
      if (val === "全部") {
        this.storeysHigh = [0];
        this.queryRoomPicture.storeys = ["全部"];
        this.getAll();
        return;
      }
      const indexInArr = this.storeysHigh.indexOf(index);
      if (indexInArr === -1) {
        this.storeysHigh.push(index);
        this.queryRoomPicture.storeys.push(val);
        if (this.storeysHigh.includes(0)) {
          this.storeysHigh = this.storeysHigh.filter((item) => item !== 0);
          // this.storeysHigh.shift(0)
        }
        if (this.queryRoomPicture.storeys.includes("全部")) {
          // this.queryRoomPicture.storeys.shift('全部')
          this.queryRoomPicture.storeys = this.queryRoomPicture.storeys.filter(
            (item) => item !== "全部"
          );
        }
      } else {
        if (this.storeysHigh.length === 1) return;
        this.storeysHigh.splice(indexInArr, 1);
        this.queryRoomPicture.storeys = this.queryRoomPicture.storeys.filter(
          (str) => str !== val
        );
      }
      this.getAll();
    },
    // 处理排序
    separateAndSort(array) {
      // 分离数字楼层与非数字字符串
      let numericFloors = [];
      let stringFloors = [];

      for (const floor of array) {
        const num = Number(floor);
        if (!isNaN(num)) {
          numericFloors.push(num);
        } else {
          stringFloors.push(floor);
        }
      }

      // 去重并排序数字楼层
      numericFloors = [...new Set(numericFloors)];
      numericFloors.sort((a, b) => a - b);

      // 将数字楼层转换回原来的格式
      let sortedNumericFloors = numericFloors.map((floor) => `${floor}楼`);

      // 合并并排序整个数组
      let result = [...stringFloors, ...sortedNumericFloors];
      result.sort((a, b) => {
        // 保证'全部'始终在最前面
        if (a === "全部") return -1;
        if (b === "全部") return 1;

        // 对于其他楼层名称，尝试将它们转为数字进行比较
        const numA = Number(a.replace("楼", ""));
        const numB = Number(b.replace("楼", ""));

        if (!isNaN(numA) && !isNaN(numB)) {
          return numA - numB;
        }

        // 如果都不能转为数字，则保持原始顺序不变（这里默认它们是按字母顺序排列的）
        return a.localeCompare(b);
      });
      result = [...new Set(result)];
      return result;
    },
    // 房间号、单位名称查询
    roomNumberQuery() {
      this.getAll();
      // this.getCountRoom();
      this.getAdjustRoom();
      this.getBuildingAndStorey();
    },

    // 点击房态图卡片进入详情
    roomDetailClick(row) {
      this.$router.push({
        name: "房态图详情",
        params: {
          // isTalent: false,
          ceshi: this.ceshi,
        },
      });
      sessionStorage.setItem("id", row.id);
    },

    // 分页
    // 当前页
    handleCurrentChange(val) {
      console.log(val);
      this.currentPage = val;
      this.getAll();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getAll();
    },

    querySearchAsync2(queryString, cb) {
      this.$http
        .get("/api/ownerManage/getOwners?company=" + this.queryRoomPicture.company)
        .then((res) => {
          console.log("查询所有单位信息", res);
          let result = res.data.data;
          cb(result);
        });
    },

    // 解决el-autocomplete使用clearable，失效问题
    clearSearch() {
      this.$refs.myAutocomplete.handleFocus();
    },
  },
};
</script>

<style scoped>
.partOne {
  display: flex;
  margin-top: 30px;
  /* justify-content: space-evenly; */
}

.roomNumCard {
  width: 16%;
  padding: 20px;
  border-radius: 5px;
  color: white;
  margin-left: 3%;
}

.roomNumCard > p:nth-of-type(1) {
  text-align: center;
  margin: 5px 0 15px;
  font-size: 15px;
}

.roomNumCard > p:nth-of-type(2) {
  text-align: center;
}

.roomNumCard > p:nth-of-type(2) span:nth-of-type(1) {
  font-weight: bold;
  font-size: 24px;
}

.roomNumCard > p:nth-of-type(2) span:nth-of-type(2) {
  font-size: 12px;
  margin-left: 10px;
}

.allRooms {
  margin-top: 25px;
  display: flex;
  flex-wrap: wrap;
}

.roomCard {
  width: 20%;
  padding: 20px;
  border-radius: 5px;
  margin: 12px 0 12px 3%;
  background-color: white;
  position: relative;
}

.roomCard > p:nth-of-type(1) {
  text-align: left;
  margin: 5px 0 15px;
  font-weight: bold;
}

.roomCard > p:nth-of-type(2) {
  font-style: normal;
  color: #666666;
}

.roomCard span {
  position: absolute;
  top: 0;
  right: 0;
  color: white;
  padding: 4px 6px;
  border-top-right-radius: 3px;
}

.queryCondition {
  margin: 30px;
  padding-top: 15px;
}

.queryCondition p span {
  width: 80px;
  height: 35px;
  text-align: center;
  line-height: 35px;
  border-radius: 20px;
  margin: 10px;
  border: 1px solid #e7e9f2;
  color: #909090;
  font-size: 15px;
  display: inline-block;
  background-color: #ffffff;
}

.queryCondition p span:hover {
  cursor: pointer;
}

.isSelected {
  background-color: #b5ac8b !important;
  color: white !important;
}

.background {
  padding-right: 15px;
}

.partTwo {
  width: 100%;
  background-color: #f5f6fa;
}
.list {
  width: 100%;
}
>>> .el-input-group__append {
  background-color: #b5ac8b;
  border: none;
}

>>> .el-icon-search {
  color: white;
}
</style>
